export const getAuthRedirectPath = (targetPath = '') => {
  const path = targetPath || `${window.location.pathname || '/'}${window.location.search || ''}${window.location.hash || ''}`;
  if (!path || path === '/' || path.startsWith('/auth')) return '/auth';
  return `/auth?redirect=${encodeURIComponent(path)}`;
};
